import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CenterInContainerDirective } from './directives/center-in-container.directive';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoginBase } from './shared/LoginBase';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PlatformIdmModule } from '@platform-idm/sdk-angular';
import { environment } from '../environments/environment';
import { AuthenticationOptions } from '@platform-idm/sdk-javascript';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { CustomErrorHandler } from './shared/CustomErrorHandler';
import { SharedModule } from './shared/shared.module';
import { AlertComponent } from './shared/alert/alert.component';
import { CompareValidatorDirective } from './shared/compare-validator.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


let options: AuthenticationOptions = {
  app: 'at',
  backendServices: [environment.login_service_url],
  environmentName: environment.environmentName,
  loginUrl: '/login',
  logoutUrl: '/logout',
  sso_serviceUrl: environment.login_service_url,
  ssoUrl: window.location.origin,
  useBuiltInTimeoutDialogBox: true,
  hideRememberMe: true,
  afterLoginRedirectTo: '/create-session'
};


@NgModule({
  declarations: [
    AppComponent,
    LoginBase,
    LoginComponent,
    LogoutComponent,

  ],
  bootstrap: [AppComponent], imports: [PlatformIdmModule.initAuth(options),
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule.forRoot() //https://valor-software.com/ngx-bootstrap/
  ], providers: [
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    provideHttpClient(withInterceptorsFromDi()),

  ]
})
export class AppModule { }
